const baseFilters = {
  advertType: 'RentApartment',
  items: {
    CityId: 1,
    PriceFrom: null,
    PriceTo: null,
    Currency: 'som',
    DurationRent: null,
    RoomCount: [],
    Type: 'apartment',
    Commerce: 0,
    DistrictId: null
  }
}

export default {
  skipAdverts: 0,
  advertsCount: null,
  token: null,
  language: null,
  countAdverts: null,
  userInfo: {},
  cityList: [],
  advertsList: [],
  userAdverts: [],
  userCompany: [],
  dynamicFilters: [],
  rangeFilters: [],
  currencyList: [],
  advertItems: [],
  newPropertyList: [],
  districtList: [],
  advertItem: {},
  editAdvert: {},
  baseFilters: Object.assign({}, baseFilters),
  loading: { getAdvertsList: false },
  coordinates: { latitude: 42.87621, longitude: 74.603746 },
  viewType: 'list',
  markerCoords: { latitude: 0, longitude: 0 }
}
